export const startComponentId = 'start';
export const componentWidth: number = 140;
export const componentHeight: number = 140;

export const computeXAngle = (
  fromX: number,
  fromY: number,
  toX: number,
  toY: number
) => {
  const height = toY - fromY;
  const width = toX - fromX;
  const hypotenuse = Math.sqrt(height*height + width*width);
  return Math.acos(width / hypotenuse) * 180 / Math.PI;
}

export const objectsEqual = function (object1: object, object2: object) {
  // Loop through properties in object 1
  for (var p in object1) {
    // Check property exists on both objects
    if (object1.hasOwnProperty(p) !== object2.hasOwnProperty(p)) return false;
    switch (typeof (object1[p])) {
      // Deep compare objects
      case 'object':
        if (!objectsEqual(object1[p], object2[p])) return false;
        break;
      // Compare function code
      case 'function':
        if (typeof (object2[p]) == 'undefined' || (p != 'compare' && object1[p].toString() != object2[p].toString())) return false;
        break;
      // Compare values
      default:
        if (object1[p] != object2[p]) return false;
    }
  }
  // Check object 2 for any extra properties
  for (var p in object2) {
    if (typeof (object1[p]) == 'undefined') return false;
  }
  return true;
}